import React from "react";
import { Lock, Play, CheckCircle2, Sparkles, Radio, Loader } from "lucide-react";
import { getStateMeta } from "../../../utils/smartLearning";

const ICONS = {
  locked: Lock,
  available: Play,
  live: Radio,
  in_progress: Loader,
  completed: CheckCircle2,
  mastered: Sparkles,
};

/**
 * SessionStateBadge — single-pill status indicator.
 * Used on session cards, the Continue Learning hero, and the roadmap.
 */
const SessionStateBadge = ({ state, size = "md" }) => {
  const meta = getStateMeta(state);
  const Icon = ICONS[state] || Play;
  const classes = ["lp-state-badge", `lp-state-badge--${state}`, `lp-state-badge--${size}`]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} aria-label={meta.label}>
      {state === "live" && <span className="lp-state-badge__pulse" />}
      <Icon size={size === "sm" ? 12 : 14} />
      <span>{meta.label}</span>
    </span>
  );
};

export default SessionStateBadge;
